// @flow

type LinkDescriptor = {|href: string, label: string|};

export const extractLinksFromMarkdocList = (list: any): Array<LinkDescriptor> =>
  list.children.map((item) => ({
    href: item.children[0].attributes.href,
    label: item.children[0].children[0],
  }));
